// ==============================|| PRESET THEME - THEME SELECTOR ||============================== //

const Theme = (colors, mode) => {
  const { gold, cyan, grey, green } = colors;
  const greyColors = {
    0: grey[0],
    50: grey[1],
    100: grey[2],
    200: grey[3],
    300: grey[4],
    400: grey[5],
    500: grey[6],
    600: grey[7],
    700: grey[8],
    800: grey[9],
    900: grey[10],
    A50: grey[15],
    A100: grey[11],
    A200: grey[12],
    A400: grey[13],
    A700: grey[14],
    A800: grey[16],
  };

  const contrastText = "#fff";

  if (mode === "light") {
    return {
      primary: {
        lighter: "#eff9ea",
        100: "#d7f0cb",
        200: "#bce7a9",
        light: "#a1dc86",
        400: "#8bd56b",
        main: "#76cc50",
        dark: "#67bc48",
        700: "#53a73e",
        darker: "#3f9334",
        900: "#137022",
        contrastText,
      },
      secondary: {
        lighter: "#e3f4f2",
        100: "#b9e3df",
        200: "#8ed2ca",
        light: "#64bfb4",
        400: "#4ab0a4",
        main: "#3aa293",
        600: "#369486",
        dark: "#318476",
        800: "#2c7367",
        darker: "#22574a",
        contrastText: greyColors[0],
      },
      error: {
        lighter: "#ffebee",
        light: "#ed6e72",
        main: "#ff3333",
        dark: "#de192c",
        darker: "#c30017",
        contrastText,
      },
      warning: {
        lighter: gold[0],
        light: gold[3],
        main: gold[5],
        dark: gold[7],
        darker: gold[9],
        contrastText: greyColors[100],
      },
      info: {
        lighter: cyan[0],
        light: cyan[3],
        main: cyan[5],
        dark: cyan[7],
        darker: cyan[9],
        contrastText,
      },
      success: {
        lighter: green[0],
        light: green[3],
        main: green[5],
        dark: green[7],
        darker: green[9],
        contrastText,
      },
      background: {
        default: "#f5f5f5",
      },
      grey: greyColors,
    };
  } else {
    return {
      primary: {
        main: "#76cc50",

        contrastText,
      },
      secondary: {
        main: "#3aa293",
      },
      error: {
        lighter: "#ffebee",
        light: "#ed6e72",
        main: "#ff3333",
        dark: "#de192c",
        darker: "#c30017",
        contrastText,
      },
      warning: {
        lighter: gold[0],
        light: gold[3],
        main: gold[5],
        dark: gold[7],
        darker: gold[9],
        contrastText: greyColors[100],
      },
      info: {
        lighter: cyan[0],
        light: cyan[3],
        main: cyan[5],
        dark: cyan[7],
        darker: cyan[9],
        contrastText,
      },
      success: {
        lighter: green[0],
        light: green[3],
        main: green[5],
        dark: green[7],
        darker: green[9],
        contrastText,
      },

      grey: greyColors,
      background: {
        paper: "#1e1e1e",
      },
    };
  }
};

export default Theme;